import {
  Add as AddIcon,
  CheckCircle,
  Help as GuideIcon,
  HourglassEmpty,
  NotificationsActive,
  Search as SearchIcon,
  Build as ServiceIcon,
  Assignment as TicketIcon,
  Person as TicketsAssignedToMeIcon,
  Groups as TicketsAssignedToGroupIcon,
  Warning,
  Info,
  Announcement,
  Schedule,
} from "@mui/icons-material";
import {
  Avatar,
  Card,
  CardContent,
  Typography,
  useTheme,
  alpha,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Badge,
} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import { useLocation, useNavigate } from "react-router-dom";

import {
  getUserDetails,
  getUserName,
  getUserProfileImage,
} from "../services/cacheService";
import HighlightedCard from "./v2/dashboard/components/HighlightedCard";
import StatCard from "./v2/dashboard/components/StatCard";
import ActivityFeed from "./v2/home/components/ActivityFeed";
import ServiceStatus from "./v2/home/components/ServiceStatus";
import { brand } from "./v2/shared-theme/themePrimitives";
import { useEffect, useState } from "react";
import {
  JWT_TOKEN,
  USER_EMAIL_ID,
  USER_ID,
  USER_NAME,
  USER_ORG_ID,
} from "../Constants/StorageConstants";
import { USERS_URL, HOME_MY_TICKETS_COUNT, HOME_ASSIGNED_TICKETS_COUNT, HOME_RESOLVED_GROUPS_TICKETS_COUNT, ORG_NOTIFICATION_URL, HOME_SLA_ABOUT_REACHED_TICKETS_COUNT, HOME_RECENT_ACTIVITIES } from "../Constants/Constants";
import AxiosInstance from "../services/AxiosInstance";
import { Phone, Email, Build } from "@mui/icons-material";

const Home = ({ premissions }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [myTicketsCount, setMyTicketsCount] = useState(0);
  const [assignedTicketsCount, setAssignedTicketsCount] = useState(0);
  const [resolverGroupTickets, setResolverGroupTickets] = useState(0);
  const [organizationalNotifications, setOrganizationalNotifications] = useState([]);
  const [slaAboutToReachTickets, setSlaAboutToReachTickets] = useState(0);
  const [activities, setActivities] = useState([]);
  const [openTicketDialog, setOpenTicketDialog] = useState(false);

  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [totalRows, setTotalRows] = useState(0);


  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.substring(1));
    const token = params.get("token");
    const userId = params.get("id");

    if (token) {
      //const userId = new URLSearchParams(window.location.search).get("id");
      localStorage.removeItem(JWT_TOKEN);
      localStorage.removeItem(USER_NAME);
      localStorage.removeItem(USER_ID);
      localStorage.removeItem(USER_ORG_ID);
      localStorage.removeItem(USER_EMAIL_ID);
      localStorage.setItem(JWT_TOKEN, token);
      AxiosInstance.get(`${USERS_URL}/${encodeURIComponent(userId)}`).then(
        (response) => {
          var userData = response.data.data;
          localStorage.setItem(USER_NAME, userData.name);
          localStorage.setItem(USER_ID, userData.id);
          localStorage.setItem(USER_ORG_ID, userData.orgId);
          localStorage.setItem(USER_EMAIL_ID, userData.emailId);
        }
      );
    }

    fetchMyTickets();
    fetchAssignedTickets();
    fetchResolvedGroupsTickets();
    fetchNotifications();
    getAboutToBreachedTickets();
    fetchRecentActivities(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const fetchMyTickets = () => {
    AxiosInstance.get(HOME_MY_TICKETS_COUNT + localStorage.getItem(USER_ID))
      .then((response) => {
        setMyTicketsCount(response.data);
      })
      .catch((err) => console.error(err));
  };

  const fetchAssignedTickets = () => {
    AxiosInstance.get(HOME_ASSIGNED_TICKETS_COUNT + localStorage.getItem(USER_ID))
      .then((response) => {
        setAssignedTicketsCount(response.data);
      })
      .catch((err) => console.error(err));
  };

  const fetchResolvedGroupsTickets = () => {
    AxiosInstance.get(HOME_RESOLVED_GROUPS_TICKETS_COUNT + localStorage.getItem(USER_ID))
      .then((response) => {
        setResolverGroupTickets(response.data);
      })
      .catch((err) => console.error(err));
  };

  const getAboutToBreachedTickets = () => {
    AxiosInstance.get(`${HOME_SLA_ABOUT_REACHED_TICKETS_COUNT}/${localStorage.getItem(USER_ID)}`)
      .then((response) => {
        setSlaAboutToReachTickets(response.data);
      })
      .catch((err) => console.error(err));
  };

  const fetchRecentActivities = async (pageNo, size) => {
    AxiosInstance.get(`${HOME_RECENT_ACTIVITIES}?page=${pageNo}&size=${size}`)
      .then((response) => {        
        setActivities(response.data.content);
        setTotalRows(response.data.totalElements);
      })
      .catch((err) => console.error(err));
  };

  const fetchNotifications = () => {
    AxiosInstance.get(`${ORG_NOTIFICATION_URL}active`)
      .then((response) => {



        setOrganizationalNotifications(response.data?.map(ntf =>
        ({
          id: ntf.id,
          type: getType(ntf.notificationType.name),
          title: ntf.title,
          message: ntf.summary,
          time: timeAgo(ntf.startDate),
          icon: getIcon(ntf.notificationType.name),
          priority: ntf.urgency.name,
        })

        ));
      })
      .catch((err) => console.error(err));
  };

  function timeAgo(createdDate) {
    const now = new Date();
    const created = new Date(createdDate);
    const diffMs = now - created; // difference in milliseconds

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) return `${seconds} seconds ago`;
    if (minutes < 60) return `${minutes} minutes ago`;
    if (hours < 24) return `${hours} hours ago`;
    if (days < 30) return `${days} days ago`;
    if (days < 365) return `${Math.floor(days / 30)} months ago`;
    return `${Math.floor(days / 365)} years ago`;
  }

  function getIcon(name) {
    if (name === "System Maintenance")
      return <Info color="info" />;
    else if (name === "New Policy Update")
      return <Announcement color="warning" />;
    else if (name === "Training Session")
      return <Schedule color="success" />;
    else if (name === "Holiday Schedule")
      return <Info color="info" />;
  }

  function getType(name) {
    if (name === "System Maintenance")
      return "info";
    else if (name === "New Policy Update")
      return "warning";
    else if (name === "Training Session")
      return "success";
    else if (name === "Holiday Schedule")
      return "info";
  }


  // Dummy user data, replace with actual data from your auth context or API

  const currentDate = new Date().toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const currentTime = new Date().toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });

  const ticketStats = {
    total: 120,
    open: 35,
    closed: 70,
    pending: 15,
  };

  // Dummy organizational notifications
  const organizationalNotifications1 = [
    {
      id: 1,
      type: "info",
      title: "System Maintenance",
      message: "Scheduled maintenance on Sunday, 2:00 AM - 6:00 AM",
      time: "2 hours ago",
      icon: <Info color="info" />,
      priority: "medium",
    },
    {
      id: 2,
      type: "warning",
      title: "New Policy Update",
      message: "Updated ticket escalation procedures effective immediately",
      time: "4 hours ago",
      icon: <Announcement color="warning" />,
      priority: "high",
    },
    {
      id: 3,
      type: "success",
      title: "Training Session",
      message: "New employee onboarding session tomorrow at 10:00 AM",
      time: "6 hours ago",
      icon: <Schedule color="success" />,
      priority: "low",
    },
    {
      id: 4,
      type: "info",
      title: "Holiday Schedule",
      message: "Office will be closed for Independence Day on July 4th",
      time: "1 day ago",
      icon: <Info color="info" />,
      priority: "medium",
    },
  ];

  const data = [
    {
      title: "Action Required: Tickets",
      count: slaAboutToReachTickets,
      description: "Tickets about to breach response/resolution time",
      route: "/tickets",
      icon: <Warning />,
      color: theme.palette.error.light,
    },
    {
      title: "Create New Ticket",
      description: "Submit a new support ticket or incident report",
      route: "/tickets",
      icon: <AddIcon />,
      color: theme.palette.primary.dark,
      openDialog: true
    },
    {
      title: "Create New Task",
      description: "Submit a new support task",
      route: "/tasks",
      icon: <AddIcon />,
      color: theme.palette.primary.dark,
      openDialog: true
    }
  ];

  const quickActions = [
    {
      title: "My Tickets",
      description: "Tickets opened by me",
      icon: <TicketIcon />,
      color: theme.palette.secondary.main,
      route: "/home",
      count: myTicketsCount,
    },
    {
      title: "Tickets Assigned",
      description: "Tickets assigned to me",
      icon: <TicketsAssignedToMeIcon />,
      color: theme.palette.info.main,
      route: "/home",
      count: assignedTicketsCount,
    },
    {
      title: "Resolver Group Tickets",
      description: "Tickets assigned to my resolver group",
      icon: <TicketsAssignedToGroupIcon />,
      color: theme.palette.success.main,
      action: "/home",
      count: resolverGroupTickets,
    },
    {
      title: "View Guides",
      description: "Access step-by-step tutorials and guides",
      icon: <GuideIcon />,
      color: theme.palette.success.main,
      action: "/home",
    },
  ];

  const userName = getUserName();
  const profileImage = getUserProfileImage();
  const userDetails = getUserDetails();

  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      {/* Compact Profile Card - Limited to 20vh */}
      <Card
        sx={{
          width: "100%",
          borderRadius: 1,
          mb: 2,
          p: 2,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.shadows[2],
          background: theme.palette.mode === "light"
            ? "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)"
            : `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
          maxHeight: "35vh",
          overflow: "hidden",
        }}
      >
        <CardContent sx={{ p: 0 }}>
          {/* Two Column Layout */}
          <Box sx={{ display: "flex", gap: 3, height: "100%" }}>
            {/* Left Column - Profile Image, Role, and Date */}
            <Box
              sx={{
                flex: "0 0 auto",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 3,
                minWidth: "350px",
                p: 2,
              }}
            >
              {/* Left side: Avatar */}
              <Avatar
                alt={userName}
                src={profileImage}
                sx={{
                  width: 70,
                  height: 70,
                  bgcolor: (theme) => theme.palette.primary.main,
                  fontSize: 28,
                  border: "3px solid #fff",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  flexShrink: 0,
                }}
              />

              {/* Right side: Text content */}
              <Box sx={{ textAlign: "left", flex: 1 }}>
                <Typography
                  variant="h1"
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    fontSize: "2rem",
                    mb: 0.5,
                    lineHeight: 1.2,
                  }}
                >
                  Welcome back!
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    color: theme.palette.text.primary,
                    fontSize: "1.2rem",
                    mb: 1,
                    lineHeight: 1.2,
                  }}
                >
                  {userDetails.name || userName}
                </Typography>
                <Chip
                  variant="outlined"
                  icon={
                    <CheckCircle fontSize="small" sx={{ color: theme.palette.primary.main }} />
                  }
                  label={
                    <span
                      style={{
                        color: theme.palette.text.primary,
                        fontSize: 12,
                        fontWeight: 500,
                      }}
                    >
                      {userDetails.role || "User"}
                    </span>
                  }
                  sx={{
                    borderColor: theme.palette.primary.main,
                    borderRadius: 2,
                    fontSize: 12,
                    px: 1.5,
                    height: 26,
                    backgroundColor: theme.palette.mode === "light" ? "#f8f9fa" : theme.palette.background.paper,
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: theme.palette.text.secondary,
                    fontSize: "0.9rem",
                    my: 0.5,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  {currentDate}
                </Typography>
              </Box>
            </Box>

            {/* Vertical Divider */}
            <Divider orientation="vertical" flexItem />

            {/* Right Column - Organizational Notifications */}
            <Box sx={{ flex: 1, overflow: "hidden" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                <NotificationsActive
                  sx={{ color: theme.palette.primary.main, mr: 1, fontSize: 20 }}
                />
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    color: theme.palette.primary.main,
                    fontSize: "1rem",
                  }}
                >
                  Organizational Notifications
                </Typography>
                <Badge
                  badgeContent={organizationalNotifications.length}
                  color="primary"
                  sx={{ ml: 3 }}
                />
              </Box>

              <List
                sx={{ p: 0, maxHeight: "calc(35vh - 80px)", overflow: "auto" }}
              >
                {organizationalNotifications.map((notification) => (
                  <ListItem
                    key={notification.id}
                    sx={{
                      p: 1,
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      display: "grid",
                      gridTemplateColumns: "40px 1fr 80px",
                      gap: 2,
                      alignItems: "flex-start",
                    }}
                  >
                    {/* Column 1: Icon */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        pt: 0.5,
                      }}
                    >
                      {notification.icon}
                    </Box>

                    {/* Column 2: Title and Message */}
                    <Box>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          fontSize: "0.875rem",
                          color: theme.palette.text.primary,
                          mb: 0.5,
                        }}
                      >
                        {notification.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "0.75rem",
                          color: theme.palette.text.secondary,
                        }}
                      >
                        {notification.message}
                      </Typography>
                    </Box>

                    {/* Column 3: Time */}
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: "0.7rem",
                        color: theme.palette.text.secondary,
                        textAlign: "right",
                        pt: 0.5,
                      }}
                    >
                      {notification.time}
                    </Typography>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* cards */}
      <Typography gap={4} component="h2" variant="h6" sx={{ mb: 2, mt: 4, color: theme.palette.text.primary }}>
        Overview
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {data.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 4 }}>
            <Card
              sx={{
                height: "100%",
                cursor: "pointer",
                transition: "all 0.3s ease",
                border: `2px solid ${card.color
                  .replace("hsl", "hsla")
                  .replace(")", ", 0.15)")}`,
                backgroundColor:
                  theme.palette.mode === "light" ? "#fff" : brand[800],
                "&:hover": {
                  boxShadow: theme.shadows[10],
                  borderColor: card.color
                    .replace("hsl", "hsla")
                    .replace(")", ", 0.40)"),
                },
              }}
              onClick={() => {
                if (card.openDialog) {
                  //setOpenTicketDialog(true);
                  navigate(card.route, {
                    state: {
                      openTicketDialog: true
                    }
                  })
                } else if (card.route) {
                  navigate(card.route);
                }
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: card.color
                        .replace("hsl", "hsla")
                        .replace(")", ", 0.15)"),
                      color: card.color,
                      p: 1,
                      borderRadius: 2,
                      mr: 2,
                    }}
                  >
                    {card.icon}
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {card.title}
                  </Typography>
                </Box>
                <Box display="flex">
                  {card.count !== null && (
                    <Typography
                      variant="h3"
                      component="div"
                      sx={{
                        color: card.color,
                        fontWeight: 800,
                        lineHeight: 1,
                        fontSize: "2.5rem",
                        textShadow: `0 2px 4px ${alpha(card.color, 0.2)}`,
                      }}
                    >
                      {card.count}
                    </Typography>
                  )}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    ml={2}
                    mt={1}
                  >
                    {card.description}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
        {/* <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <HighlightedCard />
        </Grid> */}
      </Grid>

      {/* Quick actions */}
      <Typography component="h2" variant="h6" sx={{ mb: 2, color: theme.palette.text.primary }}>
        Quick Actions
      </Typography>

      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {/* Background color for light and dark modes */}
        {quickActions.map((action, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <Card
              sx={{
                height: "100%",
                cursor: "pointer",
                transition: "all 0.3s ease",
                border: `2px solid ${action.color
                  .replace("hsl", "hsla")
                  .replace(")", ", 0.15)")}`,
                backgroundColor:
                  theme.palette.mode === "light" ? "#fff" : brand[800],
                "&:hover": {
                  boxShadow: theme.shadows[10],
                  borderColor: action.color
                    .replace("hsl", "hsla")
                    .replace(")", ", 0.40)"),
                },
              }}
              onClick={() => {
                if (action.route) {
                  navigate(action.route);
                }
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: action.color
                        .replace("hsl", "hsla")
                        .replace(")", ", 0.15)"),
                      color: action.color,
                      p: 1,
                      borderRadius: 2,
                      mr: 2,
                    }}
                  >
                    {action.icon}
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {action.title}
                  </Typography>
                </Box>
                <Box display="flex">
                  {action.count !== null && (
                    <Typography
                      variant="h3"
                      component="div"
                      sx={{
                        color: action.color,
                        fontWeight: 800,
                        lineHeight: 1,
                        fontSize: "2.5rem",
                        textShadow: `0 2px 4px ${alpha(action.color, 0.2)}`,
                      }}
                    >
                      {action.count}
                    </Typography>
                  )}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    ml={2}
                    mt={1}
                  >
                    {action.description}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>



      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        <Grid item size={{ xs: 12, sm: 6, lg: 6 }}>
          <ActivityFeed activities={activities}
            page={page}
            rowsPerPage={rowsPerPage}
            totalRows={totalRows}
            onPageChange={setPage}
            onRowsPerPageChange={(size) => {
              setRowsPerPage(size);
              setPage(0);
            }} />

        </Grid>
        <Grid item size={{ xs: 12, sm: 6, lg: 6 }}>
          <ServiceStatus />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Home;